import { useState, useEffect } from "react";
import combinedServices from "../../../../shared/services/user-service";
import pencilIcon from "../../../../assets/images/pencil.svg";
import deleteIcon from "../../../../assets/images/bin.svg";
import eyeIcon from "../../../../assets/images/eye.svg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AttributeComponent = ({
  storeID,
  attributes,
  setattributes,
  totalattributes,
  setTotalattributes,
  attributepage,
  setattributePage,
  attributelimit,
  setattributeLimit,
  attributesearchQuery,
  setattributeSearchQuery,
  attributedeleteStatus,
  setattributedeleteStatus,
  adminstoreview
}) => {
  const [selectedCategoryattri, setSelectedCategoryattri] = useState(null);
  const [selecteddeleteCategory, setSelecteddeleteCategory] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalviewOpen, setModalviewOpen] = useState(false);
  const [modaldeleteOpen, setModaldeleteOpen] = useState(false);
  const [selectedvieCategory, setSelectedviewCategory] = useState(null);

  const totalattributePages = Math.ceil(totalattributes / attributelimit);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        let attributeslist = await combinedServices.getAttribute(
          attributepage,
          attributelimit,
          attributesearchQuery,
          storeID
        );
        if (attributeslist && attributeslist.data.categories) {
          setattributes(attributeslist.data.categories || []);
          setTotalattributes(attributeslist.data.total || 0);
        }
      } catch (error) {
        console.error("Error fetching attributes:", error);
      }
    };
    fetchAttributes();
  }, [
    storeID,
    attributepage,
    attributelimit,
    attributesearchQuery,
    attributedeleteStatus,
  ]);

  const handleEditClick = (attribute) => {
    setSelectedCategoryattri(attribute);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const viewAttribute = (category) => {
    setSelectedviewCategory(category);
    setModalviewOpen(true);
  };

  const handleModalviewClose = () => {
    setModalviewOpen(false);
  };

  const deleteAttribute = (category) => {
    setSelecteddeleteCategory(category);
    setModaldeleteOpen(true);
  };

  const handleModaldeleteClose = () => {
    setModaldeleteOpen(false);
  };

  const handleattributeSearchChange = (e) => {
    setattributeSearchQuery(e.target.value);
    setattributePage(1);
  };

  const handleattributePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalattributePages) {
      setattributePage(newPage);
    }
  };
  const handleButtonClick = () => {
    navigate("/add-attribute",{ state: { storeID,adminstoreview } });
  };

  const handleattributeLimitChange = (e) => {
    setattributeLimit(Number(e.target.value));
    setattributePage(1);
  };

  const updateAttributes = async (category_id, attributes) => {
    try {
      if (!category_id || !attributes) {
        throw new Error("Category ID and name must be provided.");
      }

      const attributeData = { category_id, attributes };
      const updateAttribute = await combinedServices.updateAttributes(
        attributeData
      );

      if (updateAttribute?.status === 200) {
        setModalOpen(false);
        Swal.fire(
          "Updated!",
          updateAttribute.data.message || "The category has been Updated.",
          "success"
        );
      } else {
        Swal.fire("Warning!", "Error in updation", "warning");
      }
    } catch (error) {
      Swal.fire("Warning!", "Error in updation", error, "warning");
    }
  };

  const deleteAttributes = async (category_id, attribute_id) => {
    try {
      if (!category_id || !attribute_id) {
        throw new Error("Category ID and Attribute Id must be provided.");
      }
      const updateAttribute = await combinedServices.deleteAttribute(
        category_id,
        attribute_id
      );

      if (updateAttribute?.status === 200) {
        setModalOpen(false);
        setattributedeleteStatus(updateAttribute);
        Swal.fire(
          "Updated!",
          updateAttribute.data.message || "The category has been Updated.",
          "success"
        );
      } else {
        Swal.fire("Warning!", "Error in Deletion", "warning");
      }
    } catch (error) {
      Swal.fire("Warning!", "Error in Deletion", error, "warning");
    }
  };

  return (
    <>
      <div className="storeFilter d-flex justify-content-between align-items-center">
        <form>
          <div className="catFilterCont">
            <div className="filWrp d-flex flex-wrap align-items-center">
              <label className="label2">Showing</label>
              <select
                className="formSelect ms-2 me-2"
                value={attributelimit}
                onChange={handleattributeLimitChange}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span className="ent">entries</span>
              <div className="srchGrp ms-3">
                <input
                  type="text"
                  className="formInput"
                  value={attributesearchQuery}
                  onChange={handleattributeSearchChange}
                  placeholder="Search here..."
                />
              </div>
            </div>
          </div>
        </form>
        <button className="nambaBtn" onClick={handleButtonClick}>
          + Add New Attribute
        </button>
      </div>
      &nbsp;
      <div className="tblWrp">
        <table>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Category Name</th>
              <th>Attributes</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {attributes.map((attribute, index) => (
              <tr key={attribute.attribute_id}>
                <td>{(attributepage - 1) * attributelimit + index + 1}</td>
                <td>
                  <div className="catPara">
                    <img src={attribute.category_img} alt="categoryIcon" />
                    {attribute.category}
                  </div>
                </td>
                <td>
                  {attribute.attributes && attribute.attributes.length > 0
                    ? attribute.attributes
                        .map((attr) => attr.attributes)
                        .join(", ")
                    : "No Attributes"}
                </td>
                <td>
                  <div className="tblBtnWrp">
                    <button
                      className="Btn"
                      onClick={() => viewAttribute(attribute)}
                    >
                      <img src={eyeIcon} alt="eyeIcon" />
                    </button>
                    <button
                      className="Btn"
                      onClick={() => handleEditClick(attribute)}
                    >
                      <img src={pencilIcon} alt="pencilIcon" />
                    </button>
                    <button
                      className="Btn"
                      onClick={() => deleteAttribute(attribute)}
                    >
                      <img src={deleteIcon} alt="deleteIcon" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="tblPagiWrp">
          <ul className="pagination namPagi">
            <li>
              <button
                onClick={() => handleattributePageChange(attributepage - 1)}
                disabled={attributepage === 1}
              >
                Prev
              </button>
            </li>
            {Array.from({ length: totalattributePages }, (_, index) => (
              <li key={index}>
                <button
                  className={attributepage === index + 1 ? "active" : ""}
                  onClick={() => handleattributePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => handleattributePageChange(attributepage + 1)}
                disabled={attributepage === totalattributePages}
              >
                Next
              </button>
            </li>
          </ul>
        </div>
      </div>
      <AttributeModal
        isOpen={modalOpen}
        onClose={handleModalClose}
        category={selectedCategoryattri}
        updateAttributes={updateAttributes}
      />
      <CategoryViewModal
        isOpen={modalviewOpen}
        onClose={handleModalviewClose}
        category={selectedvieCategory}
      />
      <CategorydeleteModal
        isOpen={modaldeleteOpen}
        onClose={handleModaldeleteClose}
        category={selecteddeleteCategory}
        deleteAttributes={deleteAttributes}
      />
    </>
  );
};

const AttributeModal = ({ isOpen, onClose, category, updateAttributes }) => {
  const [categoryName, setCategoryName] = useState("");
  const [attributes, setAttributes] = useState([]);

  useEffect(() => {
    if (category) {
      setCategoryName(category.category || "");
      setAttributes(category.attributes || []);
    }
  }, [category]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (category && category.category_id && attributes.length > 0) {
      updateAttributes(category.category_id, attributes);
    } else {
      Swal.fire("Warning!", "No attributes to update.", "warning");
    }
  };

  const handleInputChange = (e, index) => {
    const updatedAttributes = [...attributes];
    updatedAttributes[index].attributes =
      e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
    setAttributes(updatedAttributes);
  };

  return (
    <div className="catagorylistmodal">
      <div className="catagorylistmodal-content">
        <h2>Edit Attributes</h2>
        <br />
        <form className="category-form">
          {attributes.length > 0 ? (
            attributes.map((attribute, index) => (
              <div key={index} className="attribute-field">
                <label htmlFor={`attribute-${index}`}>
                  Attribute {index + 1}
                </label>
                <input
                  id={`attribute-${index}`}
                  type="text"
                  value={attribute.attributes}
                  onChange={(e) => handleInputChange(e, index)}
                  placeholder={`Enter attribute ${index + 1}`}
                />
              </div>
            ))
          ) : (
            <p>No attributes available to edit.</p>
          )}
          {attributes.length > 0 && (
            <div className="catagorylistmodal-actions">
              <button type="button" className="save-btn" onClick={handleSave}>
                Save
              </button>
            </div>
          )}
        </form>
        <div className="cancel-icon" onClick={onClose}>
          &#10006;
        </div>
      </div>
      <div className="catagorylistmodal-overlay" onClick={onClose}></div>
    </div>
  );
};

const CategoryViewModal = ({ isOpen, onClose, category }) => {
  const [attributes, setAttributes] = useState([]);

  useEffect(() => {
    if (category) {
      setAttributes(category.attributes || []);
    }
  }, [category]);

  if (!isOpen) return null;

  return (
    <div className="catagorylistmodal">
      <div className="catagorylistmodal-content">
        <h2>All Attributes</h2>
        <br />
        <form className="category-form">
          {attributes.length > 0 ? (
            attributes.map((attribute, index) => (
              <div key={index} className="attribute-field">
                <label htmlFor={`attribute-${index}`}>
                  Attribute {index + 1}
                </label>
                <input
                  id={`attribute-${index}`}
                  type="text"
                  value={attribute.attributes}
                  placeholder={`Enter attribute ${index + 1}`}
                  readOnly
                />
              </div>
            ))
          ) : (
            <p>No attributes available to view.</p>
          )}
          <div className="cancel-icon" onClick={onClose}>
            &#10006;
          </div>
        </form>
      </div>
      <div className="catagorylistmodal-overlay" onClick={onClose}></div>
    </div>
  );
};

const CategorydeleteModal = ({
  isOpen,
  onClose,
  category,
  deleteAttributes,
}) => {
  const [attributes, setAttributes] = useState([]);

  useEffect(() => {
    if (category) {
      setAttributes(category.attributes || []);
    }
  }, [category]);

  if (!isOpen) return null;

  const handleSave = (attributeId) => {
    if (category && category.category_id && attributeId) {
      deleteAttributes(category.category_id, attributeId);
      setAttributes((prevAttributes) =>
        prevAttributes.filter(
          (attribute) => attribute.attribute_id !== attributeId
        )
      );
    } else {
      Swal.fire("Warning!", "No attribute selected to delete.", "warning");
    }
  };

  return (
    <div className="catagorylistmodal">
      <div className="catagorylistmodal-content">
        <h2>Delete Attributes</h2>
        <br />
        <form className="category-form">
          {attributes.length > 0 ? (
            attributes.map((attribute, index) => (
              <div key={index} className="attribute-field">
                <label htmlFor={`attribute-${index}`}>
                  Attribute {index + 1}
                </label>
                <div className="attribute-input-wrapper">
                  <input
                    id={`attribute-${index}`}
                    type="text"
                    value={attribute.attributes}
                    placeholder={`Enter attribute ${index + 1}`}
                    readOnly
                  />
                  <button
                    type="button"
                    className="delete-attribute-btn"
                    onClick={() => handleSave(attribute.attribute_id)}
                  >
                    <img src={deleteIcon} alt="deleteIcon" />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p>No attributes available to delete.</p>
          )}
          <div className="cancel-icon" onClick={onClose}>
            &#10006;
          </div>
        </form>
      </div>
      <div className="catagorylistmodal-overlay" onClick={onClose}></div>
    </div>
  );
};

export default AttributeComponent;
